/* ==========================================================================
   BSC Academy — domande frequenti · v3 · 25/08/2026

   Una risposta per volta, e il passaggio da una all'altra e animato.
   Due movimenti che partono insieme e raccontano la stessa cosa:

     1. IL SEGNO SCIVOLA. Nella lista c'e un solo segno, non uno per riga:
        il JS lo sposta dentro la riga scelta e Flip lo fa scivolare da dove
        era a dove va. Sei segni che si accendono e si spengono sarebbero un
        lampeggio; uno che si muove e un movimento.

     2. LA RISPOSTA SI SCAMBIA. La vecchia esce, la nuova entra dal basso, e
        NEL FRATTEMPO il pannello cambia altezza con una tween — non con un
        salto. E l'unico punto in cui la pagina sotto si muove, e si muove
        piano.

   ⚠️ L'altezza si misura liberando e ri-bloccando nello stesso ciclo, mai
      a scatola bloccata: a scatola bloccata la misura mente e restituisce
      quella vecchia. Stessa lezione del catalogo. → bsc-catalogo.js

   Se questo file non gira, .no-js mostra tutte le risposte e la sezione
   resta leggibile. → playbook §9.3
   ========================================================================== */
(function () {
  'use strict';

  var DUR = 0.42;

  function init(root) {
    if (!root || root.dataset.bscFaqInit) { return; }
    root.dataset.bscFaqInit = '1';

    var q = Array.prototype.slice.call(root.querySelectorAll('.bsc-faq__q'));
    var a = Array.prototype.slice.call(root.querySelectorAll('.bsc-faq__a'));
    var pannelli = root.querySelector('.bsc-faq__pannelli');
    var segno = root.querySelector('[data-bsc-segno]');
    if (!q.length || q.length !== a.length || !pannelli) { return; }

    var attivo = 0;

    function misura(el) { return el.getBoundingClientRect().height; }

    /* ---- il segno: si sposta, e se c'e Flip ci scivola ------------------ */
    function spostaSegno(i) {
      if (!segno) { return; }
      var riga = q[i].parentNode;
      if (segno.parentNode === riga) { return; }

      if (window.gsap && window.Flip) {
        var st = Flip.getState(segno);
        riga.appendChild(segno);
        Flip.from(st, { duration: DUR, ease: 'power3.inOut' });
      } else {
        riga.appendChild(segno);
      }
    }

    /* ---- lo scambio della risposta -------------------------------------- */
    function scambia(i) {
      var vecchio = a[attivo];
      var nuovo = a[i];
      var g = window.gsap;

      for (var k = 0; k < q.length; k++) {
        q[k].setAttribute('aria-selected', String(k === i));
      }

      if (!g) {                       // niente GSAP: scambio secco, tutto funziona
        for (var m = 0; m < a.length; m++) { a[m].hidden = m !== i; }
        attivo = i;
        return;
      }

      var hPrima = misura(pannelli);
      pannelli.style.height = hPrima + 'px';

      var hDopo = hPrima;
      var tl = gsap.timeline({
        onComplete: function () {
          pannelli.style.height = '';
          gsap.set(nuovo, { clearProps: 'opacity,visibility,transform' });
          if (window.ScrollTrigger) { ScrollTrigger.refresh(); }
        }
      });

      /* la vecchia esce verso l'alto: se uscisse verso il basso incrocerebbe
         la nuova che sale, e per un istante sembrerebbero la stessa cosa */
      tl.to(vecchio, { autoAlpha: 0, y: -12, duration: 0.18, ease: 'power2.in' });

      tl.add(function () {
        vecchio.hidden = true;
        gsap.set(vecchio, { clearProps: 'opacity,visibility,transform' });
        nuovo.hidden = false;

        /* misura VERA: si libera e si ri-blocca nello stesso ciclo */
        pannelli.style.height = '';
        hDopo = misura(pannelli);
        pannelli.style.height = hPrima + 'px';

        gsap.set(nuovo.children, { autoAlpha: 0, y: 16 });
      });

      /* il valore e una funzione: GSAP la legge quando la tween PARTE,
         cioe dopo la richiamata qui sopra che ha calcolato hDopo */
      tl.to(pannelli, { height: function () { return hDopo; }, duration: DUR, ease: 'power2.inOut' });

      tl.to(nuovo.children, {
        autoAlpha: 1, y: 0, duration: DUR, ease: 'power3.out', stagger: 0.07
      }, '<');

      attivo = i;
    }

    function apri(i) {
      if (i === attivo) { return; }
      spostaSegno(i);
      scambia(i);
    }

    for (var i = 0; i < q.length; i++) {
      (function (n) {
        q[n].addEventListener('click', function () { apri(n); });
        /* frecce su/giu fra le domande: e un elenco, si naviga come tale */
        q[n].addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
          if (!d) { return; }
          e.preventDefault();
          var p = (n + d + q.length) % q.length;
          q[p].focus();
          apri(p);
        });
      })(i);
    }
  }

  function tutte(scope) {
    var n = (scope || document).querySelectorAll('[data-bsc-faq]');
    for (var i = 0; i < n.length; i++) { init(n[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tutte(document); });
  } else { tutte(document); }

  document.addEventListener('shopify:section:load', function (e) { tutte(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var n = e.target.querySelectorAll('[data-bsc-faq]');
    for (var i = 0; i < n.length; i++) { delete n[i].dataset.bscFaqInit; }
  });
})();
